<div class="page" *ngIf="formData">
  <div class="content-wrapper">
    <header>
      <img src="assets/logocimfep.jpg" alt="Logo CIMFEP">
      <img src="assets/logooprag.jpg" alt="Logo OPRAG">
    </header>

    <div class="title-row">
      <div class="main-title">Fiche d’inspection Camionnage OPRAG</div>
    </div>

    <div class="meta-section">
      <table border="1">
        <tr>
          <td class="label">N° de rapport :</td>
          <td><input type="text" [(ngModel)]="formData.rapport_id"></td>
          <td class="label">Date :</td>
          <td><input type="date" [(ngModel)]="formData.date"></td>
        </tr>
        <tr>
          <td class="label">Société / Entreprise :</td>
          <td colspan="3"><input type="text"
              [(ngModel)]="formData.societe"></td>
        </tr>
        <tr>
          <td class="label">Localisation :</td>
          <td colspan="3"><input type="text"
              [(ngModel)]="formData.localisation"></td>
        </tr>
        <tr>
          <td class="label">Désignation,<br>Identification équipement :</td>
          <td colspan="3"><input type="text"
              [(ngModel)]="formData.designation"></td>
        </tr>
        <tr>
          <td class="label">Numéro de la plaque:</td>
          <td><input type="text" [(ngModel)]="formData.plaque"></td>
          <td class="label">Année:</td>
          <td><input type="text" [(ngModel)]="formData.annee"></td>
        </tr>
        <tr>
          <td class="label">Marque:</td>
          <td><input type="text" [(ngModel)]="formData.marque"></td>
          <td class="label">Model:</td>
          <td><input type="text" [(ngModel)]="formData.model"></td>
        </tr>
        <tr>
          <td class="label">N°Parc:</td>
          <td colspan="3"><input type="text" [(ngModel)]="formData.parc"></td>
        </tr>
        <tr>
          <td class="label">Numéro de série:</td>
          <td colspan="3"><input type="text" class="serial-input" maxlength="30"
              [(ngModel)]="formData.serie"></td>
        </tr>
      </table>
    </div>

    <div class="meta-section">
      <table border="1">
        <tr>
          <td style="padding: 4px;">
            <strong>Documents présentés :</strong>
            <ul class="doc-checklist">
              <li><input type="checkbox" [checked]="formData.documents.notice">
                Notice d’instruction</li>
              <li><input type="checkbox"
                  [checked]="formData.documents.maintenance"> Livret
                maintenance</li>
              <li><input type="checkbox"
                  [checked]="formData.documents.conformite"> Déclaration /
                Attestation de conformité</li>
              <li><input type="checkbox" [checked]="formData.documents.rapport">
                Rapport de contrôle précédent</li>
            </ul>
            <p class="small-text">Déclaration (écrite) du chef d'établissement,
              des travaux prévus d'être effectué par l’équipement de transport
              contrôlé (pour l'assistance d'examen d'adéquation) :</p>
          </td>
        </tr>
      </table>
    </div>

    <div class="meta-section">
      <table border="1">
        <tr>
          <td class="label">Condition d’intervention :</td>
          <td><input type="text" [(ngModel)]="formData.condition"></td>
          <td class="label">Moyen d’accès :</td>
          <td><input type="text" [(ngModel)]="formData.acces"></td>
        </tr>
        <tr>
          <td class="label">Partiel :</td>
          <td><input type="text" [(ngModel)]="formData.partiel"></td>
          <td class="label">Conducteur :</td>
          <td><input type="text" [(ngModel)]="formData.conducteur"></td>
        </tr>
        <tr>
          <td class="label">Motif contrôle :</td>
          <td colspan="3"><input type="text" [(ngModel)]="formData.motif"></td>
        </tr>
      </table>
    </div>

    <div class="container">
      <div class="column">
        <div class="section-title">1/ Points de contrôles bloquants</div>
        <div class="table-box">
          <table class="items" aria-label="Points bloquants">
            <tbody>
              <tr *ngFor="let item of formData.blockingPoints; let i = index">
                <td class="label">{{ item.label }}</td>
                <td class="check-col">C<input type="checkbox"
                    [checked]="item.value === 'C'"></td>
                <td class="check-col">N.C<input type="checkbox"
                    [checked]="item.value === 'N.C'"></td>
                <td class="check-col">B.E<input type="checkbox"
                    [checked]="item.value === 'B.E'"></td>
                <td class="check-col">M.E<input type="checkbox"
                    [checked]="item.value === 'M.E'"></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="legend-container">
          <u>Légende:</u>
          <div id="legend-items">
            <span>C = Conforme</span>
            <span>N.C = Non Conforme</span>
            <span>B.E = Bon état</span>
            <span>M.E = Mauvaise état</span>
          </div>
        </div>
      </div>

      <div class="column">
        <div class="section-title">2/ Points de contrôles non bloquants</div>
        <div class="table-box">
          <table class="items" aria-label="Points non bloquants">
            <tbody>
              <tr
                *ngFor="let item of formData.nonBlockingPoints; let i = index">
                <td class="label">{{ item.label }}</td>
                <td class="check-col">C<input type="checkbox"
                    [checked]="item.value === 'C'"></td>
                <td class="check-col">N.C<input type="checkbox"
                    [checked]="item.value === 'N.C'"></td>
                <td class="check-col">B.E<input type="checkbox"
                    [checked]="item.value === 'B.E'"></td>
                <td class="check-col">M.E<input type="checkbox"
                    [checked]="item.value === 'M.E'"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="obs-recom" role="region"
      aria-label="Observations et Recommandations">
      <div class="part">
        <div class="obs-text">
          <strong>OBSERVATIONS :</strong>
          <textarea [(ngModel)]="formData.observations"></textarea>
        </div>
        <div class="avis-section">
          <u>AVIS:</u>
          <label><input type="radio" name="avis" value="Favorable"
              [(ngModel)]="formData.avis"> Favorable</label>
          <label><input type="radio" name="avis" value="Défavorable"
              [(ngModel)]="formData.avis"> Défavorable</label>
        </div>
      </div>
      <div class="divider"></div>
      <div class="part recom-part">
        <strong>RECOMMANDATIONS :</strong>
        <textarea [(ngModel)]="formData.recommandations"></textarea>
      </div>
    </div>

    <div class="signatures">
      <div class="sign-box">
        <span>Nom du représentant entreprise</span>
      </div>
      <div class="sign-box">
        <span>Nom du représentant BA’JINN Consulting</span>
      </div>
      <div class="sign-box">
        <span>Nom du représentant CFHP Services</span>
      </div>
    </div>
  </div>

  <footer>
    <img src="assets/logocfhp.jpg" alt="Logo CFHP">
    <span>PARTENAIRES TECHNIQUES</span>
    <img src="assets/logobajin.png" alt="Logo BA'JINN">
  </footer>
</div>

<div class="print-btn">
  <button (click)="print()">🖨️ Imprimer la fiche</button>
</div>
